<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Filtros de Execução">
        <div class="form-group">
          <label class="font-weight-bold">Status</label>
          <select v-model="form.status" class="form-control">
            <option value="">Todos</option>
            <option value="COMPLETED">Sucesso</option>
            <option value="PARTIAL">Parcial</option>
            <option value="FAILED">Falhou</option>
          </select>
        </div>

        <div class="form-group">
          <label class="font-weight-bold">Tipo</label>
          <select v-model="form.mode" class="form-control">
            <option value="">Todos</option>
            <option value="FULL">Completa</option>
            <option value="MANUAL">Manual</option>
            <option value="INCREMENTAL">Incremental</option>
          </select>
        </div>

        <div class="form-group">
          <label class="font-weight-bold">Iniciada Por</label>
          <input
            v-model="form.triggeredBy"
            type="text"
            class="form-control"
            placeholder="Digite o nome do usuário..."
          >
        </div>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarFilters',
  components: {
    SidebarSearch,
    SearchCollapse
  },
  data () {
    return {
      form: {
        status: '',
        mode: '',
        triggeredBy: ''
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.form = {
        status: '',
        mode: '',
        triggeredBy: ''
      }
      this.$nextTick(() => {
        this.submitForm()
      })
    }
  }
}
</script>

<style scoped>
.form-group label {
  font-size: 0.875rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-group {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/ADSync/components/dashboard/SidebarFilters.vue